var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p-toolbar',[(_vm.scormController.file)?_c('p-toolbar-action',{attrs:{"icon":"mdi-delete","tooltip":"Delete zip scorm"},on:{"click":function($event){return _vm.scormController.removeDocument()}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }